module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.emailAddress) ? _c('div', {
    staticClass: "m-signedinInfo"
  }, [_vm._v("You are signed in as "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.emailAddress) + ". ")]), _vm._v(" "), (_vm.changeUserUrl) ? _c('a', {
    staticClass: "a-Link--Blue",
    attrs: {
      "href": _vm.changeUserUrl
    }
  }, [_vm._v("Sign in as someone else")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb0b869e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/SignIn.vue
// module id = 546
// module chunks = 2